<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Staff Attendance - Monthly Report</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">

        </div>
      </div>
    </div>
    <div>
      <monthly-report></monthly-report>
    </div>
  </div>
</template>

<script>
import monthlyReport from '@/components/StaffAttendance/monthlyreport'

export default {
  name: 'MonthlyReportIndexPage',
  components: { monthlyReport },
  data: function() {
    return {}
  },
  methods: {},
}
</script>

<style>

</style>
